<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10.4622 3.25H6.5835C5.75507 3.25 5.0835 3.92157 5.0835 4.75V15.25C5.0835 16.0784 5.75507 16.75 6.5835 16.75H14.0835C14.9119 16.75 15.5835 16.0784 15.5835 15.25V8.37132C15.5835 7.97349 15.4255 7.59197 15.1441 7.31066L11.5228 3.68934C11.2415 3.40803 10.86 3.25 10.4622 3.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M11.0835 3.625V6.25C11.0835 7.07843 11.755 7.75 12.5835 7.75H15.2085" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M8.0835 10.75H10.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M8.0835 13.75H12.9585" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PlatformDocsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>